/**
 * Скопировать текст в буфер обмена: сайт, приложение iOS (WKWebView на `capacitor://localhost`) и Android.
 *
 * ⚠️ ЗВАТЬ ПРЯМО ИЗ ОБРАБОТЧИКА НАЖАТИЯ, БЕЗ `await` ДО ЗАПИСИ. Safari и WKWebView пускают в буфер только
 * под живым жестом пользователя: после ожидания сети жест «остывает», и запись отклоняется. Поэтому образец
 * `AccessCopyButton` (сперва запрос пароля, потом запись) сюда не годится.
 *
 * Запасной путь — временное поле и `execCommand('copy')`: на случай, когда `navigator.clipboard` нет
 * (незащищённый источник, старый WebView) или он отказал. Поле — `textarea`: в приложении выделение снято со
 * всей страницы (`html.native body`, index.css), а поля ввода оставлены выделяемыми.
 */
export async function copyText(text: string): Promise<boolean> {
  const clip = typeof navigator !== 'undefined' ? navigator.clipboard : undefined;
  if (clip?.writeText) {
    try {
      await clip.writeText(text);
      return true;
    } catch {
      /* отказ — пробуем запасной путь */
    }
  }
  return copyViaTextarea(text);
}

function copyViaTextarea(text: string): boolean {
  if (typeof document === 'undefined') return false;
  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  // За краем экрана, но в документе: невидимое через display:none не выделяется.
  area.style.position = 'fixed';
  area.style.top = '0';
  area.style.left = '-9999px';
  area.style.opacity = '0';
  document.body.appendChild(area);
  try {
    area.select();
    area.setSelectionRange(0, text.length);
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    area.remove();
  }
}
